import React from "react";

const SendConfig = ({ config, onChange }) => {
    const set = (field, value) => onChange({ ...config, [field]: value });
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    return (
        <>
            <div className="crm-option-pills">
                <button
                    type="button"
                    className={`crm-option-pill${config.sendImmediately !== false ? " crm-option-pill--active" : ""}`}
                    onClick={() => set("sendImmediately", true)}
                >
                    Send immediately
                </button>
                <button
                    type="button"
                    className={`crm-option-pill${config.sendImmediately === false ? " crm-option-pill--active" : ""}`}
                    onClick={() => set("sendImmediately", false)}
                >
                    Schedule
                </button>
            </div>

            {config.sendImmediately === false && (
                <div style={{ marginBottom: "var(--space-3)" }}>
                    <input
                        type="datetime-local"
                        value={config.scheduledAt || ""}
                        onChange={(e) => set("scheduledAt", e.target.value || null)}
                        style={{ width: "100%", boxSizing: "border-box", padding: "var(--space-2) var(--space-3)", border: "1px solid var(--color-border)", borderRadius: "var(--radius-md)", fontSize: "var(--text-sm)", background: "var(--color-bg-primary)", color: "var(--color-text-primary)", outline: "none" }}
                    />
                </div>
            )}

            <label className="crm-send-config-row">
                <input
                    type="checkbox"
                    checked={!!config.timeWindowOnly}
                    onChange={(e) => set("timeWindowOnly", e.target.checked)}
                />
                Business hours only (9AM–5PM)
            </label>

            <div style={{ marginTop: "var(--space-3)", fontSize: "var(--text-xs)", color: "var(--color-text-secondary)" }}>
                Timezone: {tz}
            </div>
        </>
    );
};

export default SendConfig;
